import { uurlTestToolStyle } from './uurl-test-tool-style';
import { customParametersStyle } from './custom-parameters-style';

export const urlFieldStyle = (/* components, theme */) => ({
  '& .url-protocol': {
    width: 'auto',
    marginRight: 10,
    float: 'left',
  },
  '& .url-field': {
    width: '50%',
  },
});

export const uurlStyle = (components, theme) => ({
  '& .upgraded-url': {
    ...urlFieldStyle(components, theme),

    '& .url': {
      marginLeft: 0,
    },
    '& .mobile-url': {
      marginLeft: 0,
    },
    '& .upgraded-url-options-preview__label': {
      marginLeft: 10,
    },
    '& .upgraded-url-options-preview__value': {
      marginLeft: 10,
      width: 500,
      wordWrap: 'break-word',
    },
    '& .tracking-template__container': {
      width: 500,
    },

    '& .fieldItemAd': {
      marginLeft: 0,
    },
    '& .fieldRowAd .col-sm-offset-4': {
      marginLeft: 0,
    },
    '& .advanced-options .col-sm-offset-4.col-sm-8': {
      marginLeft: 0,
    },
    '& .url-options .col-sm-offset-4.col-sm-8': {
      marginLeft: 0,
    },
    '& .advanced-options .col-sm-8.form-control-static': {
      marginLeft: 10,
    },
    '& .url-options .col-sm-8.form-control-static': {
      marginLeft: 10,
    },
    '& .advanced-options .col-sm-8.uurl-test-tool__container': {
      marginLeft: 15,
    },

    ...uurlTestToolStyle(theme),
    ...customParametersStyle(components, theme),
  },
});
